import { render, staticRenderFns } from "./AfterSalesMobile.vue?vue&type=template&id=1ead7a0e&scoped=true&"
import script from "./AfterSalesMobile.vue?vue&type=script&lang=js&"
export * from "./AfterSalesMobile.vue?vue&type=script&lang=js&"
import style0 from "./AfterSalesMobile.vue?vue&type=style&index=0&id=1ead7a0e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ead7a0e",
  null
  
)

export default component.exports